// drawer/blankSubstance.ts
// Factory for a blank SubstanceRow used when opening the drawer in "add" mode.
// Ported from sl-panel.jsx 709–715.
//
// Uses a simple incrementing counter so consecutive calls in the same session
// get distinct ids without relying on Date.now() inside a React render cycle.
// The counter is module-level (stable across hot reloads in dev).

import type { SubstanceRow } from "../_model";

// Extended blank type — includes extraIds for identifier round-trip.
export type BlankSubstance = SubstanceRow & { extraIds: { kind: string; value: string }[] };

let _counter = 0;

export function blankSubstance(id?: string): BlankSubstance {
  const resolvedId = id ?? `s-new-${++_counter}-${Date.now()}`;
  return {
    id: resolvedId,
    name: "",
    type: "compound",
    family: "fruity",
    code: "",
    cas: [],
    ec: [],
    fema: [],
    internal: [],
    extraIds: [],
    usage: ["ingredient"],
    status: "READY",
    added: new Date().toISOString().slice(0, 10),
    lastUsed: null,
    tags: [],
    chrom: 0,
    formula: null,
    stock: null,
  };
}
